// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"6370bf63e6c7ac0d","6831":"6c848d86c6fed7ed","8503":"475830d17adbe97b","9683":"2e55408c37778354"}[chunkId] + ".js";
};